import { RefObject } from "react";
import { useMediaQuery, useTheme } from "@mui/material";
import { useMuiNavHeight } from "src/hooks/use-mui-nav-height";
import { getSmoothScrollBehavior } from "src/utils/dom/reduced-motion/reduced-motion";

export const useScrollToTableTop = (containerRef: RefObject<HTMLDivElement>, offset = 0) => {
    const { NAV_HEIGHT_VARIATION } = useMuiNavHeight();
    const theme = useTheme();
    const isMdUp = useMediaQuery(theme.breakpoints.up("md"));
    const isSmUp = useMediaQuery(theme.breakpoints.up("sm"));
    let navHeight = NAV_HEIGHT_VARIATION.xs;

    if (isMdUp) {
        navHeight = NAV_HEIGHT_VARIATION.md;
    } else if (isSmUp) {
        navHeight = NAV_HEIGHT_VARIATION.sm;
    }

    const navHeightOffset = navHeight + offset;

    return () => {
        const container = containerRef.current;

        if (!container) {
            return;
        }

        const { top } = container.getBoundingClientRect();

        if (top < navHeightOffset) {
            window.scrollTo({ top: window.scrollY + top - navHeightOffset, behavior: getSmoothScrollBehavior() });
        }
    };
};
